import { Quotes, Star } from "@phosphor-icons/react";
import { Reveal, Overline } from "./Reveal";
import { TESTIMONIALS } from "../../data/site";

export const Testimonials = () => (
    <section
        data-testid="testimonials"
        className="border-t border-border bg-surface/30"
    >
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-36">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
                <div>
                    <Reveal>
                        <Overline>Kata Pelanggan</Overline>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.02]">
                            Dipercayai pemilik kucing.
                        </h2>
                    </Reveal>
                </div>
                <Reveal delay={0.16}>
                    <div className="flex items-center gap-2 text-accent">
                        {[...Array(5)].map((_, i) => (
                            <Star key={i} size={20} weight="fill" />
                        ))}
                        <span className="ml-2 text-ink-soft text-sm">
                            4.9 / 5 · 500+ tempahan berpuas hati
                        </span>
                    </div>
                </Reveal>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                {TESTIMONIALS.map((t, i) => (
                    <Reveal key={t.name} delay={i * 0.1}>
                        <figure className="h-full flex flex-col justify-between border border-border bg-bg p-8 hover:border-accent/40 transition-colors duration-500">
                            <Quotes size={34} weight="fill" className="text-accent/70" />
                            <blockquote className="mt-6 text-lg text-ink leading-relaxed font-display italic">
                                “{t.quote}”
                            </blockquote>
                            <figcaption className="mt-8 flex items-center gap-4 pt-6 border-t border-border">
                                <img
                                    src={t.image}
                                    alt={t.name}
                                    className="h-12 w-12 rounded-full object-cover"
                                />
                                <div>
                                    <div className="text-ink font-semibold">{t.name}</div>
                                    <div className="text-sm text-ink-soft">{t.loc}</div>
                                </div>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
